import { FC, RefObject } from 'react'
import styled from 'styled-components'
import { Box, Button, Color, Text, theme } from '@mrshmllw/smores-react'

type RegistrationInputProps = {
  showExitSurveyBtn?: boolean
  setPlateNumber: (regPlate: string) => void
  setShowExitModal: (show: boolean) => void
  searching: boolean
  regPlate: string
  inputRef?: RefObject<HTMLInputElement | null>
  textColour: Color
  fullWidthSubmit: boolean
  useAsSubmit: boolean
  form: string
  buttonVariant: 'primary' | 'secondary'
  error: boolean
  errorMsg?: string
}

export const RegistrationInput: FC<RegistrationInputProps> = ({
  showExitSurveyBtn = false,
  setPlateNumber,
  setShowExitModal,
  searching,
  regPlate,
  inputRef,
  textColour,
  fullWidthSubmit,
  buttonVariant,
  useAsSubmit,
  form,
  error,
  errorMsg,
}) => {
  const buttonProps = {
    [buttonVariant]: true,
    form,
    loading: searching,
    forcedWidth: fullWidthSubmit ? '100%' : undefined,
  }

  return (
    <Container>
      <Text mb="16px" typo="headline-regular" color={textColour}>
        Enter vehicle number plate
      </Text>
      <InputWrapper mb="8px" maxWidth="275px" $error={error}>
        <GBSection>GB</GBSection>
        <StyledInput
          ref={inputRef}
          placeholder="number plate"
          onChange={(e) => setPlateNumber(e.target.value)}
          value={regPlate}
        />
      </InputWrapper>
      <Box height="12px" mb="8px">
        {error && (
          <Text color="strawberry" typo="caption">
            {errorMsg}
          </Text>
        )}
      </Box>
      <Button type={useAsSubmit ? 'submit' : 'button'} {...buttonProps}>
        Find vehicle
      </Button>
      {showExitSurveyBtn && (
        <TextButton
          type="button"
          textBtn
          mt="32px"
          mb="16px"
          onClick={() => setShowExitModal(true)}
          $colour={textColour}
        >
          I don&apos;t know it
        </TextButton>
      )}
    </Container>
  )
}

const StyledInput = styled.input`
  display: flex;
  padding-left: 10px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border: 1px solid transparent;
  border-radius: 12px;
  height: 60px;
  font-size: 32px;
  color: ${theme.colors.liquorice};
  font-family: MarshmallowYouth;
  text-transform: uppercase;
  line-height: 40px;
  width: 100%;

  &::placeholder {
    color: ${theme.colors.chia};
  }
`

const InputWrapper = styled(Box)<{ $error: boolean }>`
  display: flex;
  background-color: ${theme.colors.cream};
  border-radius: 12px;
  border: ${(p) =>
    p.$error ? `2px solid ${theme.colors.strawberry}` : `2px solid ${theme.colors.oatmeal}`};
  height: 60px;
  overflow: hidden;
  max-width: 343px;
`

const GBSection = styled(Box)`
  width: 70px;
  background-color: ${theme.colors.macaroon};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: MarshmallowYouth;
  font-size: 32px;
  line-height: 40px;
  height: 60px;
`

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: 768px) {
    #exitSurveyBtn {
      display: none;
    }
  }
`

const TextButton = styled(Button)<{ $colour: Color }>`
  color: ${({ $colour }) => theme.colors[$colour]};
`
